import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

// ✅ Your real VAPID Public Key (Base64 URL Safe)
const publicVapidKey = 'BF15zCGJoE0nEkNjXBefDqeIJf7qRA7zY9OLQWJcCiu7cETJhhtfomUZfI3Rk-QLUMRE6EkOBM6Tt1dCCrkD_8A';

// ✅ Service Worker + Push Setup
if ('serviceWorker' in navigator && 'PushManager' in window) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then(async (reg) => {
        console.log('✅ Service Worker registered:', reg.scope);

        try {
          // Request notification permission
          if (Notification.permission !== 'granted') {
            const permission = await Notification.requestPermission();
            if (permission !== 'granted') {
              console.warn('🚫 Notifications permission denied.');
              return;
            }
          }

          // Get existing subscription or subscribe new
          let subscription = await reg.pushManager.getSubscription();
          if (!subscription) {
            subscription = await reg.pushManager.subscribe({
              userVisibleOnly: true,
              applicationServerKey: urlBase64ToUint8Array(publicVapidKey)
            });
          }

          console.log('📡 Push Subscription:', subscription);

          // Send subscription to backend
          await fetch(`${process.env.REACT_APP_API_URL || ''}/api/push/subscribe`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(subscription)
          });

          console.log('✅ Push subscription saved to server');
        } catch (err) {
          console.error('❌ Push subscription failed:', err);
        }
      })
      .catch((err) => {
        console.error('❌ SW registration failed:', err);
      });
  });
} else {
  console.warn('❌ Push messaging is not supported in this browser.');
}

// 🔹 Convert VAPID key to Uint8Array
function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  return Uint8Array.from([...rawData].map((char) => char.charCodeAt(0)));
}
